import { useState } from "react";
import { useDispatch } from "react-redux";

import "./GuestWelcome.css";
import logo from "../../../../Assets/newsie-triumphant-192-removebg.png";
import { dismissModal, setModal } from "../../../../redux/features/modalSlice";
import { setLoginModalScreen } from "../../../../redux/features/authSlice";
import WinnerSubscribe from "../Winner/WinnerSubscribe";
import { DEFAULT } from "../Login";

export const GUEST_WELCOME_SHOWN_KEY = "guestWelcomeShownDate";

// Shown when a guest starts the daily game: explains Newsie and asks for an email,
// with login and "just play" as the other ways out
const GuestWelcome = () => {
  const dispatch = useDispatch();
  const [subscribed, setSubscribed] = useState(false);

  const close = (e) => {
    e.stopPropagation();
    dispatch(dismissModal());
  };

  const login = (e) => {
    e.stopPropagation();
    dispatch(dismissModal());
    dispatch(setLoginModalScreen(DEFAULT));
    dispatch(setModal("LOGIN"));
  };

  return (
    <div className="guest-welcome-modal" onClick={(e) => e.stopPropagation()}>
      <img src={logo} alt="" width={72} height={72} />
      <h2>Welcome to Newsie!</h2>
      <p className="guest-welcome-pitch">
        Every day we hide 7 real news headlines behind clues. Rebuild each one
        from 3 words to crack the puzzle.
      </p>
      <WinnerSubscribe
        title="📬 Get it in your inbox"
        text="A short read of today's top stories each morning, then the puzzle to test your memory. Free."
        fallbackSource="guest_welcome"
        onDone={() => setSubscribed(true)}
      />
      <button className="guest-welcome-play" onClick={close}>
        {subscribed ? "Start playing →" : "Just play →"}
      </button>
      {!subscribed && (
        <div className="guest-welcome-login">
          Already subscribed?{" "}
          <button className="guest-welcome-link" onClick={login}>
            Log in
          </button>
        </div>
      )}
    </div>
  );
};

export default GuestWelcome;
